import { createFileRoute } from "@tanstack/react-router";
import Schedule from "@/pages/Schedule";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/schedule")({
  head: () =>
    seo({
      title:
        "Schedule a Free Roof or Siding Inspection | Cedar Creek Construction",
      description:
        "Pick a date and time window for your free inspection with Cedar Creek Construction. Licensed Minnesota roofing and siding contractor serving the Minneapolis north metro.",
      path: "/schedule",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Schedule an Inspection", path: "/schedule" },
      ]),
    }),
  component: Schedule,
});
